//import { Tab, Tabs } from "@mui/material";
import { t } from "i18next";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { useSelector } from "react-redux";
import { useGetStudioServicesQuery } from "../../api/user/servicesStudioApi";
//import { useNavigate } from "react-router-dom";
//import { useGetOtherServicesQuery } from "../../api/user/altriServiziApi";

const AltriServiziPage = () => {
  //const [selectedCategory, setSelectedCategory] = useState("Tutti");

  const studioId = useSelector((state) => state.app.studioId);
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  /*   const { data: otherServices, isLoading } = useGetOtherServicesQuery(
    studioId,
    {
      skip: studioId,
    }
  ); */
  const { data: serviceStudio, isLoading: loadingServiceStudio } =
    useGetStudioServicesQuery(studioId, { skip: !studioId });

  //const navigate = useNavigate();

  /*   const handleChange = (event, newValue) => {
    setSelectedCategory(newValue);
  }; */

  /*   const filteredServices =
    selectedCategory === "Tutti"
      ? otherServices && otherServices.Data
      : otherServices &&
        otherServices.Data.filter(
          (service) => service.Category === selectedCategory
        ); */

  return (
    <div className="w-full">
      {/*       <Tabs
        value={selectedCategory}
        onChange={handleChange}
        aria-label="Altri Servizi Tabs"
      >
        <Tab label="Tutti" value="Tutti" />
        <Tab label="Finanziari" value="FINANZIARI" />
        <Tab label="Pianificazione Fiscale" value="PIANIFIC_FISCALE" />
        <Tab
          label="Assistenziali e Previdenziali"
          value="ASSIST_PREVIDENZIALI"
        />
      </Tabs> */}
      {serviceStudio?.Data?.otherServices.map((service) => (
        <div className="flex py-8 items-center space-x-12" key={service.Id}>
          <div className="w-28">
            {service.iconUrl ? (
              <img
                src={service.iconUrl}
                className="w-full h-full"
                alt={service.name}
              />
            ) : (
              <p className="text-gray">No logo</p>
            )}
          </div>
          <div className="w-6/12">
            <h3 className="m-0">{service.name}</h3>
            <p className="m-0">{service.description}</p>
            <h3 style={{ color: colorPrimary }}>{service.commission} €</h3>
          </div>
          <CoreButton className={"btn-round"}>
            <a
              href={service.website}
              target="_blank"
              rel="noopener noreferrer"
              className=" no-underline text-white "
            >
              {t("Discover")}
            </a>
          </CoreButton>
        </div>
      ))}
    </div>
    /*  filteredServices.map((service) => (
            <div className="flex py-8 items-center space-x-12" key={service.id}>
              <div className="w-28">
                {service.iconUrl ? (
                  <img
                    src={service.iconUrl}
                    className="w-full h-full"
                    alt={service.name}
                  />
                ) : (
                  <p className="text-gray">Nessun logo</p>
                )}
              </div>
              <div className="w-6/12">
                <h3 className="m-0">{service.name}</h3>
                <p className="m-0">{service.description}</p>
                <h3 className="text-primary">{service.commission} €</h3>
              </div> */
    /*               <CoreButton
                testo={`cerca ${LABELS.studio}`}
                className={"btn-round"}
                onClick={() =>
                  navigate(`/auth/user/associa-${ENV_ROUTES.studio}`)
                }
              /> */
  );
};

export default AltriServiziPage;
